export default "__VITE_ASSET__5996b7c8__"